import 'css-chunk:src/feature/provision/ProvisionItemList.module.scss';export default {
  "list": "ProvisionItemList_list"
};